<div class="clock">
  <div class="day">
    {{ dayMoment | titlecase }}
  </div>
  <div class="date">
    {{ dateMoment }}
  </div>
  <div class="hour">
    {{ hourMoment }}
  </div>
</div>
